var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgServiceCo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_882_211)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1.08173,
    y: 1.08173,
    width: 47.8365,
    height: 47.8365,
    rx: 4.91827,
    stroke: "#F8F7ED",
    strokeWidth: 2.16346
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.7583 20.3723C17.145 21.255 16.5527 23.2784 17.4354 24.8917C18.3181 26.505 20.3415 27.0973 21.9548 26.2146L31.3262 21.0872C32.9395 20.2045 33.5318 18.1811 32.6491 16.5678C31.7664 14.9545 29.743 14.3622 28.1297 15.2449L18.7583 20.3723ZM19.4153 29.0355C17.802 29.9182 17.2097 31.9416 18.0924 33.5549C18.9751 35.1683 20.9985 35.7605 22.6118 34.8778L31.1742 30.1931C32.7875 29.3104 33.3798 27.287 32.4971 25.6737C31.6144 24.0604 29.591 23.4681 27.9777 24.3508L19.4153 29.0355Z",
    fill: "#F8F7ED"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_882_211"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceCo);
export default __webpack_public_path__ + "static/media/ServiceCo.fb3ae8b9d18c63b295fe56e91e772fec.svg";
export { ForwardRef as ReactComponent };